import { type z } from 'zod'

export type EntityDefinition<Entry, Draft> = {
	readonly schema: z.ZodTypeAny
	readonly createDraft: () => Draft
	readonly sanitizeDraft: (draft: Draft) => Draft
	readonly serialize: (draft: Draft) => Entry
	readonly deserialize: (entry: Entry) => Draft
	readonly collectErrors?: (draft: Draft) => readonly string[]
}

export type EntityCollectionItem<Entry, Draft> = {
	readonly index: number
	readonly entry: Entry
	readonly draft: Draft
	readonly errors: readonly string[]
}

export function assertEntityDefinition<Entry, Draft>(
	definition: EntityDefinition<Entry, Draft>,
): EntityDefinition<Entry, Draft> {
	return definition
}
